document.addEventListener("DOMContentLoaded", function() {
  const products_on_page = document.getElementById('product-grid');
  const nextUrl = document.getElementById('paginateNext');
  let next_url = nextUrl ? nextUrl.dataset.nextUrl : '';

  const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
  const load_more_spinner = document.getElementsByClassName('loading__spinner')[0];
  let actualProductCount = products_on_page.getElementsByClassName('grid__item').length;

  async function getNextPage(url) {
    try {
      let res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.text();
    } catch (error) {
      console.error('Failed to fetch next page:', error);
      load_more_btn.style.display = 'flex'; 
      load_more_spinner.style.display = 'none'; 
    }
  }

  async function loadMoreProducts() {
    if (!next_url) {
      console.warn('No more pages to load.');
      return;
    }

    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'block';

    let nextPage = await getNextPage(next_url);
    if (!nextPage) return; 

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    // Update next URL
    const newUrl = nextPageDoc.getElementById('paginateNext');
    next_url = newUrl ? newUrl.dataset.nextUrl : '';

    const productgrid = nextPageDoc.getElementById('product-grid');
    if (productgrid) {
      const new_products = productgrid.getElementsByClassName('grid__item');
      for (let i = 0; i < new_products.length; i++) {
        products_on_page.appendChild(new_products[i].cloneNode(true));
        actualProductCount++; // Increment count only for products
      }
    }

    load_more_btn.style.display = next_url ? 'flex' : 'none';
    load_more_spinner.style.display = 'none';

    console.log('Actual Products Loaded:', actualProductCount);
  }

  if (load_more_btn) {
    load_more_btn.addEventListener('click', loadMoreProducts);
  }
});
